import { render, staticRenderFns } from "./CleanerLayout.vue?vue&type=template&id=31227a24&scoped=true"
import script from "./CleanerLayout.vue?vue&type=script&lang=js"
export * from "./CleanerLayout.vue?vue&type=script&lang=js"
import style0 from "./CleanerLayout.vue?vue&type=style&index=0&id=31227a24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31227a24",
  null
  
)

export default component.exports